import { render, staticRenderFns } from "./ClientesFuncionalidadeDialog.vue?vue&type=template&id=37dbaf00&scoped=true&lang=pug"
import script from "./ClientesFuncionalidadeDialog.vue?vue&type=script&lang=js"
export * from "./ClientesFuncionalidadeDialog.vue?vue&type=script&lang=js"
import style0 from "./ClientesFuncionalidadeDialog.vue?vue&type=style&index=0&id=37dbaf00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dbaf00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDataTable,VDialog,VDivider,VIcon,VSpacer})
